import merge from 'lodash/merge'
import minBy from 'lodash/minBy'
import maxBy from 'lodash/maxBy'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import { mapState, mapMutations } from 'vuex'
import { currentLevel } from '@/utils/members'
import { getMemberInfo, getMemberConfig } from '@/api/member'
import { storage } from '@/utils/storage'
import { getCouponList } from '@/api/fission'
import { memberGrade } from '../pages/Members/firebase'
import { textFormat } from '@/utils/pluralRules.js'

let NextLevel = 0

export default {
  computed: {
    ...mapState(['region', 'userInfo', 'members', 'allowUseMember']),
    swipe_privileges8() {
      return this.$t('member.privileges8')
    },
    swipe_membership_tips() {
      return function (currencySymbol, discountedPrice) {
        const level = currentLevel(NextLevel)
        return {
          membership_tips: this.$t('member.membership_tips', {
            currencySymbol,
            discountedPrice,
            level,
          }),
        }
      }
    },
    swipe_membership_tips1() {
      return function (discountRatio) {
        const level = currentLevel(NextLevel)
        return {
          membership_tips1: this.$t('member.membership_tips1', {
            discountRatio,
            level,
          }),
        }
      }
    },
    swipe_membership_tips2() {
      return function (amount) {
        const level = currentLevel(NextLevel)
        let massgae = this.$t('member.membership_tips2')
        if (massgae.indexOf('{level}') > -1) {
          massgae = massgae.replace('{level}', level)
        }
        return {
          membership_tips2: textFormat(massgae, amount),
        }
      }
    },
    privileges_tip() {
      return function (amount) {
        return {
          privileges_tip: textFormat(this.$t('member.privileges_tip'), amount),
        }
      }
    },
  },
  created() {
    if (!process.client) return
    let massgae = this.$t('member.membership_tips2')
    if (massgae.indexOf('{level}') > -1) {
      massgae = massgae.replace('{level}', 999)
    }
    if (!isEmpty(this.userInfo)) {
      this.initRequest()
    }
  },
  watch: {
    userInfo: {
      handler(newVal) {
        if (!isEmpty(newVal)) {
          this.initRequest(true)
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations([
      'setMembersUserInfo',
      'setMembersUserConfig',
      'setMembersCardSwipe',
    ]),
    // 初始化接口请求
    // type 根据类型做缓存处理
    async initRequest(type = false) {
      if (!this.allowUseMember) return

      const info = await this._getMemberInfo(type)
      const configs = await this._getMemberConfig(type)

      if (!info || !configs) return

      this._loadMemberSwipe(info, configs)
      const users = this.getUserPortrait(info, configs)
      this._renderTips(users, configs)
    },
    // 查询当前登录用户会员信息
    async _getMemberInfo(type) {
      try {
        if (!type) {
          const members = this.members || {}
          const { userInfo = {} } = members
          if (Object.keys(userInfo).length) return userInfo
        }
        const result = await getMemberInfo(this.region)

        if (Object.keys(result).length) {
          const leveldoc = currentLevel(result.levelCode)
          const data = merge(result, { leveldoc })
          this.setMembersUserInfo(data)
          const { name = 'xxx' } = this.$route
          memberGrade(name, { grade: `${result.levelCode}` })
          return data
        }
      } catch (error) {
        window.console.warn('%c[getMemberInfo]方法报错', 'color:#0f0', error)
        return false
      }
    },
    // 查询会员配置及奖品
    async _getMemberConfig(type) {
      try {
        if (!type) {
          const members = this.members || {}
          const { userConfig = [] } = members
          if (userConfig.length) return userConfig
        }

        let result = await getMemberConfig(this.region)

        if (result && result.length) {
          this.setMembersUserConfig(result)
          storage.set('membersUserConfig', result)
          return result
        }
      } catch (error) {
        window.console.warn('%c[getMemberConfig]方法报错', 'color:#0f0', error)
        return false
      }
    },
    // 查询优惠券数据
    async _getCouponList(couponIdString) {
      const country = this.region
      try {
        const couponList = await getCouponList({
          country,
          couponIdString,
        })

        return couponList
      } catch (error) {
        window.console.warn('%c[_getCouponList]方法报错', 'color:#0f0', error)
        return false
      }
    },

    async _loadMemberSwipe(userInfo, userConfig) {
      let levelCode = userInfo?.levelCode

      // 左侧菜单卡片底部的swipe
      let swipeList = []

      // kb
      let kbs = null

      // 优惠券id集合
      let coupons = null
      let result = null

      // 当前等级是最高等级时，不展示轮播
      if (userConfig[userConfig.length - 1].levelCode === levelCode) {
        this.setMembersCardSwipe([])
        storage.set('membersCardSwipe', [])
        return
      }

      // 根据当前等级 获取config配置文件下一等级KB
      for (let i = levelCode + 1; i < userConfig.length; i++) {
        if (userConfig[i].KGoldCount) {
          NextLevel = i
          kbs = userConfig[i]
          break
        }
      }

      // 获取以当前用户起点往下的等级优惠券信息
      for (let i = levelCode + 1; i < userConfig.length; i++) {
        if (userConfig[i].couponIds && userConfig[i].couponIds.length) {
          NextLevel = i
          coupons = userConfig[i]
          break
        }
      }

      if (kbs) {
        swipeList.push({
          icon: 'td_v2',
          massage: this.swipe_membership_tips2(kbs.KGoldCount).membership_tips2,
        })
      }

      if (coupons) {
        result = await this.mergeMemberSwipe(coupons)
      }

      swipeList = result ? swipeList.concat(result) : swipeList
      this.setMembersCardSwipe(swipeList)
      storage.set('membersCardSwipe', swipeList)
    },

    // 左侧菜单会员信息获取当前等级的头像
    getUserPortrait(userInfo, userConfig) {
      // 未登录的时候 不执行

      if (typeof userInfo === 'boolean' && !userInfo) return

      const { levelCode } = userInfo
      const { awardListVO } = userConfig.find(
        (item) => item.levelCode === levelCode
      )
      if (awardListVO && awardListVO.length) {
        // 根据 VIP = 1 为头像框
        let result = ''

        awardListVO.forEach((item) => {
          if (item.itemList && item.itemList.length) {
            let n = item.itemList.find((i) => i.item === 1)
            if (n) {
              result = n
            }
          }
        })
        const data = { ...userInfo, ...{ portrait: result.content } }
        return data
      }
      return userInfo
    },

    // 合并数据源
    async mergeMemberSwipe(coupons) {
      if (!coupons.couponIds) return
      const couponIds = coupons.couponIds.toString()
      const couponList = (await this._getCouponList(couponIds)) || []
      const result = couponList.map((item) => {
        const swipeItem = {}
        swipeItem._type = item.couponType
        swipeItem._couponDiscount =
          item.couponType == 2 ? item.couponDiscount : ''
        swipeItem._couponPrice = item.couponType == 1 ? item.couponPrice : ''
        swipeItem.icon = `coupons_v2`
        swipeItem.massage =
          item.couponType === 1
            ? this.swipe_membership_tips(item.currency, item.couponPrice)
                .membership_tips
            : this.swipe_membership_tips1(`${100 - item.couponDiscount}%`)
                .membership_tips1
        return swipeItem
      })
      return result
    },

    async _renderTips(userInfo, userConfig) {
      const { levelCode } = userInfo

      // 重新赋值用户信息
      let copyUserInfo = cloneDeep(userInfo)

      // KB
      let kbs = ''

      // 优惠券相关
      let couponsRes = null,
        coupons = null,
        couponMsg = ''

      // 当前等级如果和配置文件最后一个等级相等、直接返回
      // if (userConfig[userConfig.length - 1].levelCode === levelCode) {
      //   copyUserInfo.couponMsg = ''
      //   copyUserInfo.kbMsg = ''
      //   this.setMembersUserInfo(copyUserInfo)
      //   storage.set('membersUserInfo', copyUserInfo)
      //   return
      // }

      // for (let i = levelCode; i < userConfig.length; i++) {
      //   if (userConfig[i].KGoldCount) {
      //     kbs = userConfig[i]
      //     break
      //   }
      // }
      if (userConfig.length) {
        // 根据当前等级 获取config配置文件当前等级KB
        const kbsList = userConfig.filter(
          (item) => item.levelCode === levelCode
        )
        if (kbsList.length > 0 && kbsList[0]?.KGoldCount) {
          kbs = kbsList[0]
        }

        // 获取以当前用户起点往下的等级优惠券信息
        const couponsList = userConfig.filter(
          (item) => item.levelCode === levelCode
        )
        if (couponsList.length > 0 && couponsList[0]?.couponIds) {
          coupons = couponsList[0]
        }
      }

      // 拼接KB
      if (kbs) {
        copyUserInfo.kbMsg = this.privileges_tip(
          `${kbs.KGoldCount}`
        ).privileges_tip
      }

      // 获取优惠券接口
      if (coupons) {
        couponsRes = await this.mergeMemberSwipe(coupons)
      }

      // 优惠券 优先展示折扣卷 > 满减卷
      // 如果折扣卷有多张、展示折扣力度最大的；
      // 满减卷也一样、展示满减力度最大的；

      if (couponsRes) {
        // 折扣劵
        const discountCoupon = couponsRes.filter((item) => item._type === 2)
        // 满减卷
        const fulldiscount = couponsRes.filter((item) => item._type === 1)

        if (discountCoupon && discountCoupon.length) {
          // 优先展示折扣力度最大
          let _couponDiscount = minBy(
            discountCoupon,
            '_couponDiscount'
          )._couponDiscount

          couponMsg = `${100 - _couponDiscount}%OFF`
        } else if (fulldiscount && fulldiscount.length) {
          // 优先展示满减力度最大
          let _couponPrice = maxBy(fulldiscount, '_couponPrice')._couponPrice
          couponMsg = `${_couponPrice}${this.$t('common.my_coupon')}`
        }
      }

      copyUserInfo.couponMsg = couponMsg

      this.setMembersUserInfo(copyUserInfo)
      storage.set('membersUserInfo', copyUserInfo)
    },
  },
}
